// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1YiF2","title":"FrontImage_title__3FvhS"};